import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Image, Stack, Text, useStyleConfig} from '@chakra-ui/react'
import DynamicIcon from '@app/components/dynamic-icon/DynamicIcon'

const CarouselTabs = ({tabs = [], activeIndex = 0, onChange, idPrefix}) => {
    const styles = useStyleConfig('CarouselCards')

    if (tabs.length <= 1) return null

    const getTabId = (index) => `${idPrefix}-tab-${index}`

    const focusTab = (index) => {
        onChange(index)
        document.getElementById(getTabId(index))?.focus()
    }

    const handleKeyDown = (event, index) => {
        switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                event.preventDefault()
                focusTab(index === 0 ? tabs.length - 1 : index - 1)
                break
            case 'ArrowRight':
            case 'ArrowDown':
                event.preventDefault()
                focusTab(index === tabs.length - 1 ? 0 : index + 1)
                break
            case 'Home':
                event.preventDefault()
                focusTab(0)
                break
            case 'End':
                event.preventDefault()
                focusTab(tabs.length - 1)
                break
            case 'Enter':
            case ' ':
                event.preventDefault()
                onChange(index)
                break
            default:
                break
        }
    }

    return (
        <Flex {...styles?.tabListContainer} data-testid="carousel-cards-tabs">
            <Stack role="tablist" aria-label="carousel cards tabs" {...styles?.tabListShell}>
                {tabs.map((tab, index) => {
                    const isActive = index === activeIndex

                    return (
                        <Flex
                            key={tab?._metadata?.uid || getTabId(index)}
                            as="label"
                            role="tab"
                            id={getTabId(index)}
                            aria-controls={`${idPrefix}-panel-${index}`}
                            aria-selected={isActive}
                            tabIndex={isActive ? 0 : -1}
                            onClick={() => onChange(index)}
                            onKeyDown={(event) => handleKeyDown(event, index)}
                            {...styles?.tab}
                            {...(isActive ? styles?.tabActive : {})}
                        >
                            {tab?.fico_id ? (
                                <DynamicIcon iconId={tab?.fico_id} {...styles?.tabIcon} />
                            ) : tab?.icon?.url ? (
                                <Image
                                    src={tab?.icon?.url}
                                    alt=""
                                    aria-hidden="true"
                                    {...styles?.tabIcon}
                                />
                            ) : (
                                <></>
                            )}
                            <Text as="span">{tab?.name}</Text>
                        </Flex>
                    )
                })}
            </Stack>
        </Flex>
    )
}

CarouselTabs.propTypes = {
    tabs: PropTypes.array,
    activeIndex: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    idPrefix: PropTypes.string.isRequired,
}

export default CarouselTabs
